import React from 'react';
import './CompetitionPrizePill.css';

type CompetitionPrize = 'empty' | 'money' | 'badge' | 'unknown';

function normalizePrize(input?: string | null): CompetitionPrize {
  const raw = (input || '').trim().toLowerCase();
  if (!raw || raw === 'empty' || raw === 'none') return 'empty';
  if (raw === 'money' || raw === 'badge') return raw;
  return 'unknown';
}

function labelForPrize(prize: CompetitionPrize): string {
  switch (prize) {
    case 'money':
      return 'Money prize';
    case 'badge':
      return 'Badge prize';
    default:
      return '';
  }
}

export interface CompetitionPrizePillProps {
  prize?: string | null;
  className?: string;
  showLabel?: boolean;
}

const CompetitionPrizePill: React.FC<CompetitionPrizePillProps> = ({
  prize,
  className = '',
  showLabel = false,
}) => {
  const normalized = normalizePrize(prize);
  if (normalized === 'empty' || normalized === 'unknown') return null;

  const label = labelForPrize(normalized);

  return (
    <span
      className={`competition-prize-pill competition-prize-pill--${normalized} ${className}`.trim()}
      title={`Prize: ${label}`}
      aria-label={`Prize: ${label}`}
    >
      {normalized === 'money' ? (
        <span className="competition-prize-pill__glyph" aria-hidden="true">$</span>
      ) : (
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 3.5 14.8 9l6 .6-4.5 3.9 1.4 5.7L12 16l-5.7 3.2 1.4-5.7L3.2 9.6l6-.6L12 3.5Z" />
        </svg>
      )}
      {showLabel && <span className="competition-prize-pill__label">{label}</span>}
    </span>
  );
};

export default CompetitionPrizePill;
